import { injector } from "@/services";
import {
  ERROR_SERVICE_INJECTION_KEY,
  ROUTER_SERVICE_INJECTION_KEY,
} from "@/constants";
import { ROUTE_ERROR_SESSION_EXPIRED_NAME } from "../constants";
import { useSystemStore } from "../services/store";

export { shouldRedirectToSessionExpired } from "./should-redirect-to-session-expired.util";

export const redirectToSessionExpiredPage = async (): Promise<void> => {
  const router = injector.injectFromRoot(ROUTER_SERVICE_INJECTION_KEY);
  const errorService = injector.injectFromRoot(ERROR_SERVICE_INJECTION_KEY);

  errorService.blockDisplay();
  const $systemStore = useSystemStore();
  $systemStore.stopHealthCheck();

  if (router.currentRoute.value.name !== ROUTE_ERROR_SESSION_EXPIRED_NAME) {
    await router.push({ name: ROUTE_ERROR_SESSION_EXPIRED_NAME });
  }
};
